import React, { useState } from "react";
import { withdrawalRecoveryEntries, retryRecordedWithdrawal } from "./withdrawalRecovery";

export default function WithdrawalRecovery() {
    const [busy, setBusy] = useState(false);
    const [notice, setNotice] = useState("");
    let entries = [];
    try { entries = withdrawalRecoveryEntries(); } catch { /* Storage is unavailable. */ }
    if (!entries.length) return null;
    return <section aria-label="Previous withdrawal requests" style={{ marginTop: 12, overflowWrap: "anywhere" }}>
        <h3>Previous withdrawal requests</h3>
        <p>Consenting again starts a new research enrollment for future contributions only. Previous records remain withdrawn, and their deletion requests continue separately.</p>
        <p>Private credentials are retained only for deletion follow-up, independently of game IDs. Clearing browser data will remove these credentials; contact the controller if recovery is needed.</p>
        {entries.map(entry => <p key={entry.participant_id}>{entry.participant_id}: {entry.receipt.deletion_request_id || "Withdrawal confirmed; request receipt needs recovery."}{" "}
            <button type="button" disabled={busy} onClick={async () => {
                setBusy(true); setNotice("");
                try { const result = await retryRecordedWithdrawal(entry.participant_id); setNotice(`Follow-up recorded: ${result.deletion_request_id}. Public-copy propagation and backup erasure are not automatically confirmed.`); }
                catch (error) { setNotice(error.message); } finally { setBusy(false); }
            }}>Follow up deletion request</button></p>)}
        {notice && <p role="status">{notice}</p>}
    </section>;
}
